import { queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { apiClient } from "../../../../zodios/client";
import { clientToServerFiltering } from "../../../../components/table/utils";
import { useDates } from "../../../../dates/DatesContext";

type Params = {
  filters?: ColumnFiltersState;
  search?: string;
  allActive: boolean;
};

export const useGetV4OrgReportTotals = (marketPlace: string) => {
  const { start, end, preStart, preEnd } = useDates();
  return (params: Params) => {
    const filters = params.filters;
    const search = params.search ? params.search.split(",") : [];

    return queryOptions({
      queryKey: [{ entity: "V4OrgReportTotals", marketPlace, params, dates: { start, end, preStart, preEnd } }],
      queryFn: async () =>
        await apiClient.getV4OrgReportTotals({
          queries: {
            marketplace: marketPlace,
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
            start_date_previous: preStart.format("YYYY-MM-DD"),
            end_date_previous: preEnd.format("YYYY-MM-DD"),
            filters: clientToServerFiltering(filters),
            search,
            all_active_orgs: params.allActive ? "true" : undefined,
          },
        }),
    });
  };
};
